<template>
	<h2 class="mt-5 has-text-centered has-text-weight-bold is-size-3 title has-text-black">
        {{title}}
    </h2>
</template>
<script>
export default {
	name : 'PageTitle',
	props : {
		title : {
			default : 'Dashboard'
		}
	},
	data(){
		return {
			
		}
	}
}
</script>
<style scoped>
	
</style>